import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import EtiquetasCoreTable from "./EtiquetasCoreTable"
import { EtiquetasCoreView } from "./EtiquetasCoreView"
import { EtiquetasCoreDelete } from "./EtiquetasCoreDelete"
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

import { Breadcrumbs } from '../General/Breadcrumbs';
import authService from '../api-authorization/AuthorizeService'

export class EtiquetasCoreProveedor_Index extends Component {
    static displayName = EtiquetasCoreProveedor_Index.name;
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { nombre: "", producto_Id: 0, tipoFruta_Id: 0, colilla_Id: 0, carton_Id: 0, habilitado: true },
            productos: [],
            tiposFruta: [],
            colillas: [],
            cartones: []
        };
        this.load_colillas = this.load_colillas.bind(this);
        this.load_cartones = this.load_cartones.bind(this);
        this.load_productos = this.load_productos.bind(this);
        this.load_tiposFruta = this.load_tiposFruta.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            {/*<Col md="2">*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label for="producto_Id">*/}
                            {/*            <FormattedMessage id='Producto' />*/}
                            {/*        </Label>*/}
                            {/*        <Input*/}
                            {/*            id="producto_Id"*/}
                            {/*            name="producto_Id"*/}
                            {/*            type="select"*/}
                            {/*            onChange={this.handleSearchChange}*/}
                            {/*        >*/}
                            {/*            <option value="0"></option>*/}
                            {/*            {this.state.productos.map(producto => producto.producto_Id == this.state.searchModel.producto_Id ? (*/}
                            {/*                <option value={producto.producto_Id} selected>*/}
                            {/*                    {producto.nombre}*/}
                            {/*                </option>*/}
                            {/*            ) : (<option value={producto.producto_Id}>{producto.nombre}</option>))}*/}
                            {/*        </Input>*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            <Col md="2">
                                <FormGroup>
                                    <Label for="tipoFruta_Id">
                                        <FormattedMessage id='TiposFruta' />
                                    </Label>
                                    <Input
                                        id="tipoFruta_Id"
                                        name="tipoFruta_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.tiposFruta.map(tipoFruta => tipoFruta.tipoFruta_Id == this.state.searchModel.tipoFruta_Id ? (
                                            <option value={tipoFruta.tipoFruta_Id} selected>
                                                {tipoFruta.nombre}
                                            </option>
                                        ) : (<option value={tipoFruta.tipoFruta_Id}>{tipoFruta.nombre}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="colilla_Id">
                                        <FormattedMessage id='Colilla' />
                                    </Label>
                                    <Input
                                        id="colilla_Id"
                                        name="colilla_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.colillas.map(colilla => colilla.colilla_Id == this.state.searchModel.colilla_Id ? (
                                            <option value={colilla.colilla_Id} selected>
                                                {colilla.nombre}
                                            </option>
                                        ) : (<option value={colilla.colilla_Id}>{colilla.nombre}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="carton_Id">
                                        <FormattedMessage id='Carton' />
                                    </Label>
                                    <Input
                                        id="carton_Id"
                                        name="carton_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.cartones.map(carton => carton.carton_Id == this.state.searchModel.carton_Id ? (
                                            <option value={carton.carton_Id} selected>
                                                {carton.nombre}
                                            </option>
                                        ) : (<option value={carton.carton_Id}>{carton.nombre}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="nombre">
                                        <FormattedMessage id='EtiquetaCore' />
                                    </Label>
                                    <FormattedMessage id='Nombre'>
                                        {(placeholder) =>
                                            <Input
                                                id="nombre"
                                                name="nombre"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleSearchChange}
                                                value={this.state.searchModel.nombre}
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <EtiquetasCoreTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal size="lg" isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = [
            { link: "/EtiquetasCore", message: "Flujo de trabajo", active: true },
            { link: "/EtiquetasCore", message: "EtiquetasCore", active: false },
        ];
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div>
                <h2><FormattedMessage id='EtiquetasCore' /></h2>
                <Breadcrumbs data={breadcrumbsData} />
                
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({ loading: true, tiposFruta: await this.load_tiposFruta(), colillas: await this.load_colillas(), cartones: await this.load_cartones() }, async () => {
            const token = await authService.getAccessToken();
            var queryString = '?';
            Object.keys(this.state.searchModel).forEach(key => {
                queryString += key + "=" + this.state.searchModel[key] + "&";
            });
            queryString = queryString.slice(0, -1);
            const response = await fetch('api/etiquetasCore' + queryString, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const responceData = await response.json();
            this.setState({ data: responceData, loading: false });
        });
        
    }

    async handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, async () => {
            if (event.target.name == "producto_Id") {
                this.setState({
                    tiposFruta: await this.load_tiposFruta()
                });
            }
        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><EtiquetasCoreView setModalBodyState={this.setModalBodyState}></EtiquetasCoreView></div>);
        //return (<div><EtiquetasCoreView ref={this.modalBodyState}></EtiquetasCoreView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/etiquetasCore', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><EtiquetasCoreView setModalBodyState={this.setModalBodyState} data={responceData}></EtiquetasCoreView></div>);
        //return (<div><EtiquetasCoreView ref={this.modalBodyState}></EtiquetasCoreView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/etiquetasCore/' + this.modalBodyState.etiquetaCore_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><EtiquetasCoreDelete setModalBodyState={this.setModalBodyState} data={responceData}></EtiquetasCoreDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore/' + this.modalBodyState.etiquetaCore_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { nombre: "", producto_Id: 0, tipoFruta_Id: 0, colilla_Id: 0, carton_Id: 0 }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_colillas() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/colillas/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_cartones() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/cartones/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_productos() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/productos/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_tiposFruta() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/tiposFruta?producto_Id=' + this.state.searchModel.producto_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
}